export const LOADING_CSV = {
  pt: "Carregando",
  es: "Cargando",
  en: "Loading",
};
